/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LadderChallenge } from './LadderChallenge';
import {
    LadderChallengeFromJSON,
    LadderChallengeFromJSONTyped,
    LadderChallengeToJSON,
    LadderChallengeToJSONTyped,
} from './LadderChallenge';

/**
 * 
 * @export
 * @interface ForfeitLadderChallengeResponse
 */
export interface ForfeitLadderChallengeResponse {
    /**
     * 
     * @type {LadderChallenge}
     * @memberof ForfeitLadderChallengeResponse
     */
    challenge: LadderChallenge;
}

/**
 * Check if a given object implements the ForfeitLadderChallengeResponse interface.
 */
export function instanceOfForfeitLadderChallengeResponse(value: object): value is ForfeitLadderChallengeResponse {
    if (!('challenge' in value) || value['challenge'] === undefined) return false;
    return true;
}

export function ForfeitLadderChallengeResponseFromJSON(json: any): ForfeitLadderChallengeResponse {
    return ForfeitLadderChallengeResponseFromJSONTyped(json, false);
}

export function ForfeitLadderChallengeResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ForfeitLadderChallengeResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'challenge': LadderChallengeFromJSON(json['challenge']),
    };
}

export function ForfeitLadderChallengeResponseToJSON(json: any): ForfeitLadderChallengeResponse {
    return ForfeitLadderChallengeResponseToJSONTyped(json, false);
}

export function ForfeitLadderChallengeResponseToJSONTyped(value?: ForfeitLadderChallengeResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'challenge': LadderChallengeToJSON(value['challenge']),
    };
}

